/**
 * RefType danh mục
 */
export default {
  CustomerVendor: 9001, // Khách hàng, nhà cung cấp
  Employee: 9002, // Cán bộ
  EmployeeType: 3, // Loại cán bộ
};
